module.exports = __webpack_public_path__ + "static/media/xxJy@4x.8672c734.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xxJy@4x.png
// module id = 1875
// module chunks = 0 1